import React from 'react';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';

function Layout({ children, headerTitle = "Dashboard", headerSubtitle = "Bem-vindo ao sistema" }) {
  return (
    <div className="flex h-screen bg-[#f1f5f9]">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content - Ocupa 80% da tela (espaço restante após a sidebar de 20%) */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Top Bar - Ocupa toda a largura disponível, mas conteúdo interno é 90% */}
        <header className="bg-white shadow-sm border-b border-gray-200 py-4 w-full">
          <div className="w-[90%] ml-[5%]">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-[#231f20]">{headerTitle}</h1>
                <p className="text-sm text-gray-600">{headerSubtitle}</p>
              </div>
              
              {/* Top Right Actions */}
              <div className="flex items-center space-x-4">
                {/* Notifications */}
                <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors duration-200">
                  <div className="relative">
                    <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5v-5z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 002 2z" />
                    </svg>
                    <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full"></span>
                  </div>
                </button>
                
                {/* User Menu */}
                <UserMenu />
              </div>
            </div>
          </div>
        </header>
        
        {/* Page Content - Ocupa toda a largura disponível, mas conteúdo interno é 90% */}
        <main className="flex-1 overflow-y-auto py-6 w-full">
          <div className="w-[90%] ml-[5%]">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;
